import React, {useState, useEffect} from 'react';
import Typography from '@mui/material/Typography';
import { FormControl, Grid, InputAdornment, Link, OutlinedInput, styled, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import AlertInfo from '../../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
import SearchIcon from '@mui/icons-material/Search';
import { Search } from '@mui/icons-material';
interface SearchQuery {
    id: number;
    searchQuery: string;
    searchTime: string;
}

const StyledTableRow = styled(TableRow)(() => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#fafafa',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const SearchEngineSearchQueriesList = () => {

    const [searchInput, setSearchInput] = useState('');
    const [searchQueries, setSearchQueries] = useState<SearchQuery[]>();
    const [allQueries, setAllQueries] = useState<SearchQuery[]>();

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    //payload
    useEffect(() => {
        getSearchQueries();
    }, [searchInput])

    const getSearchQueries = async () => {
        await fetch(`/ItDashboard/GetSearchQueries?searchPhrase=${searchInput}`)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: ItDashboard - GetSearchQueries',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    setSearchQueries(result.result);
                    if (!searchInput)
                        setAllQueries(result.result);
                }
            }
            )
    }

    const updateSearchInput = (event: React.ChangeEvent<HTMLInputElement>) => {

        setTimeout(() => {
            let searchPhrase = event.target.value;
            if (searchPhrase === '') {
                setSearchQueries(allQueries);
            }
            else {
                setSearchInput(searchPhrase);
            }
        }, 1000)
    }

    return (
        <>
            <Typography color={'blue'} variant="subtitle1" marginBottom={4}>
                Latest Search Queries
            </Typography>
            <Grid item xs={11}>
                <FormControl sx={{ minWidth: 200, marginBottom: "15px" }} variant="outlined" size="small">
                    <OutlinedInput
                        aria-label='search...'
                        title='search queries...'
                        placeholder={"Search..."}
                        onChange={updateSearchInput}
                        startAdornment={
                            <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        }
                    />
                </FormControl>
                {
                    searchQueries && searchQueries.length > 0 &&
                    <TableContainer sx={{ maxHeight: 600 }}>
                        <Table stickyHeader size="small">
                                <TableBody>
                                 {searchQueries.map((query: SearchQuery, index) =>
                                    <StyledTableRow key={index}>
                                         <TableCell width={'30%'} >
                                             <Typography variant="body2"><i>{query.searchTime}</i></Typography>
                                        </TableCell>
                                         <TableCell>
                                             <Typography variant="body2">{query.searchQuery}</Typography>
                                         </TableCell>
                                         <TableCell>
                                             <Link href={`https://www.ocpf.us/PublicSearch/Index?q=${query.searchQuery}`} target="blank">
                                                 <SearchIcon color="primary" />
                                             </Link>
                                         </TableCell>
                                    </StyledTableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </Grid>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </>
    );
}

export default SearchEngineSearchQueriesList 